import { RouteAccessBoundary } from '../../runtime/routes/RouteAccessBoundary';

/**
 * OperationRouteGuard — compatibility alias for RouteAccessBoundary.
 *
 * The route-guard layers have been consolidated so that RouteAccessBoundary is
 * the single authority for backend route decisions. Existing consumers can keep
 * importing OperationRouteGuard; new code should prefer RouteAccessBoundary.
 */
export const OperationRouteGuard = RouteAccessBoundary;
export type OperationRouteGuardProps = Parameters<typeof OperationRouteGuard>[0];
